import type { Link, Text } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import { readString } from '../utils';

export const mention = (
	node: PMNode,
	serializeMention?: (node: PMNode) => string | undefined,
): Text | Link | null => {
	const text = readString(node.attrs.text);
	const url = serializeMention?.(node);
	const name = text?.startsWith('@') ? text.slice(1) : text;
	if (url && name) {
		return { type: 'link', url, title: null, children: [{ type: 'text', value: name }] };
	}
	return text ? { type: 'text', value: text } : null;
};
